export const API_ENDPOINTS = {
  AUTH: {
    login: () => ({
      url: '/api/v1/login/brand',
      method: 'POST',
    }),
    register: () => ({
      url: '/api/v1/register/brand',
      method: 'POST',
    }),
    verifyGst: () => ({
      url: '/api/v1/register/gst/verify',
      method: 'POST',
    }),
    changeFirstPassword: () => ({
      url: '/api/v1/password/changepasswordfirst',
      method: 'POST',
    }),
    getBussinessCategory: () => ({
      url: '/api/v1/brand-business-category',
      method: 'GET',
    }),
    getProfile: () => ({
      url: `/api/v1/profile/details`,
      method: 'GET',
    }),
    forgotPassword: () => ({
      url: `/api/v1/password/forgotpassword`,
      method: 'POST',
    }),
    resetPassword: (token, type) => ({
      url: `/api/v1/password/forgotpassword/${token}/${type}`,
      method: 'PUT',
    }),

    refreshToken: () => ({
      url: '/api/v1/login/refresh',
      method: 'POST',
    }),
  },
  CATALOG: {
    catalogueBrandDetails: () => ({
      url: '/api/v1/brandservice/catalogue',
      method: 'POST',
    }),
    catalogueFranchiseDetails: () => ({
      url: '/api/v1/brandservice/catalogue',
      method: 'POST',
    }),
    cataloguePagesDetails: () => ({
      url: '/api/v1/brandservice/catalogue',
      method: 'POST',
    }),
    catalogueAdditionalDetails: () => ({
      url: '/api/v1/brandservice/catalogue',
      method: 'POST',
    }),
    cataloguePhotosDocsDetails: () => ({
      url: '/api/v1/brandservice/catalogue',
      method: 'POST',
    }),
    catalogueAlternativeContactsDetails: () => ({
      url: '/api/v1/brandservice/catalogue',
      method: 'POST',
    }),

    getCatalogDetails: () => ({
      url: '/api/v1/brandservice/getcatalogue',
      method: 'POST',
    }),
    getDropdownData: () => ({
      url: '/api/v1/misc',
      method: 'GET',
    }),
    getBussinessCategoryData: () => ({
      url: '/api/v1/master/category',
      method: 'GET',
    }),
    getPublicBussinessCategoryData: () => ({
      url: '/api/v1/master/category/data/listall',
      method: 'GET',
    }),
    getBussinessTypeData: (sup_cat_id) => ({
      url: `/api/v1/master_business_type/${sup_cat_id}`,
      method: 'GET',
    }),
    getCategoryData: (sup_cat_id) => ({
      url: `/api/v1/category/list/${sup_cat_id}`,
      method: 'GET',
    }),
    getSubCategoryData: (cat_id) => ({
      url: `/api/v1/subCategory/list/${cat_id}`,
      method: 'GET',
    }),

    getIndustry: () => ({
      url: `/api/v1/master_industry`,
      method: 'GET',
    }),
    getCostBifurcationsData: (sup_cat_id) => ({
      url: `/api/v1/cost_bifurcations/${sup_cat_id}`,
      method: 'GET',
    }),
    getEmployeeDetailsData: (sup_cat_id) => ({
      url: `/api/v1/employee_details/${sup_cat_id}`,
      method: 'GET',
    }),
    getLicenseType: (sup_cat_id) => ({
      url: `/api/v1/license/${sup_cat_id}`,
      method: 'GET',
    }),
    publishCatalog: (catalogueId) => ({
      url: `/api/v1/brandservice/publish/catalogue/${catalogueId}`,
      method: 'POST',
    }),
  },

  COUNTRY: {
    getCountries: () => ({
      url: `/api/v1/countries`,
      method: 'GET',
    }),
    getStates: () => ({
      url: `/api/v1/states`,
      method: 'GET',
    }),
    getCities: () => ({
      url: `/api/v1/cities`,
      method: 'GET',
    }),
    getZones: () => ({
      url: `/api/v1/zones`,
      method: 'GET',
    }),
  },
  PLAN: {
    getPlans: () => ({
      url: '/api/v1/plans',
      method: 'GET',
    }),
  },
  SUBSCRIPTION: {
    createOrder: () => ({
      url: '/api/v1/order',
      method: 'POST',
    }),
    verifySignature: () => ({
      url: '/api/v1/subscription/verifyPayment',
      method: 'POST',
    }),
  },
  MANAGE_LEADS: {
    manageLeadsList: (cure) => ({
      url: '/api/v1/leads/consumebybrand',
      method: 'GET',
    }),
    getManageDetails: (cure) => ({
      url: '/api/v1/leads/detail/',
      method: 'GET',
    }),
    getReminderList: (reminderId) => ({
      url: `/api/v1/reminder/list/${reminderId}`,
      method: 'GET',
    }),
    getInvestorLeadsDetails: (pyrId) => ({
      url: `/api/v1/pyr/detail/${pyrId}`,
      method: 'GET',
    }),
    getConsumerByBrandLeadId: () => ({
      url: '/api/v1/leads/consumebybrand/status',
      method: 'PUT',
    }),
    exportManageLeads: () => ({
      url: `/api/v1/leads/consumebybrand/export`,
      method: 'GET',
    }),
  },
  CATELOG_VIEWS: {
    getCatelogViewsList: () => ({
      url: '/api/v1/brandservice/brand/contact/investors',
      method: 'GET',
    }),
    addShortList: (cure) => ({
      url: '/api/v1/brandservice/brand/contact/investor',
      method: 'PUT',
    }),
  },
  DASHBOARD: {
    fetchDashboardDetails: () => ({
      url: '/api/v1/brandservice/dashboard',
      method: 'GET',
    }),
  },
  COMMON: {
    addSupportData: (cure) => ({
      url: '/api/v1/support',
      method: 'POST',
    }),
    getSupportData: () => ({
      url: '/api/v1/support/assignee',
      method: 'GET',
    }),
  },
  SETTINGS: {
    requestOtpForEmailorPassword: () => ({
      url: '/api/v1/brand/setting/edit',
      method: 'POST',
    }),
    verifyOtpForEmail: () => ({
      url: '/api/v1/brand/setting/verifyotp',
      method: 'POST',
    }),
    updateNewEmailOrPassword: () => ({
      url: '/api/v1/brand/setting/update',
      method: 'POST',
    }),
    updateNewPassword: () => ({
      url: '/api/v1/brand/resetpass/update',
      method: 'POST',
    }),
    updateBusinessCategory: () => ({
      url: '/api/v1/brand/business/update',
      method: 'POST',
    }),
  },
};
